/** @jsx h */

import {h, render} from "preact";
import {onFind} from "@elements/init-modules-in-scope";
import {useState, useEffect} from "preact/hooks";
import {translate} from '@elements/translations';
import escapeHtml from 'escape-html';
import {findIn,addClass, closest, findAllIn, on} from '@elements/dom-utils';

const selectors = {
    base: '.js-render-booking-names',
    counterWrapper: '.js-render-booking-names__counter',
    counterLabel: '.js-render-booking-names__counter-label',
    counterInput: '.js-render-booking-names__counter-input',
    item: '.js-render-booking-names__item',
    itemTitle: '.js-render-booking-names__item-title',
    result: '.js-render-booking-names__result'
};

export function init() {
    onFind(selectors.base, function (baseElement) {

        let result = findIn(selectors.result, baseElement);
        let counterInputs = findAllIn(selectors.counterInput, baseElement);

        counterInputs.map(function(counterInput) {
            on('change', function(evt) {
                let rowsObj = [...Array(+evt.target.value).keys()];
                let input = evt.target;
                let renderName = input.getAttribute('data-render-booking-names-prefix');
                let renderCategory = input.getAttribute('data-render-booking-names-category') || false;
                let hotelTitle = findIn(selectors.itemTitle, closest(selectors.item, input)).textContent.toLowerCase();

                let roomTitle = findIn(selectors.counterLabel, closest(selectors.counterWrapper, input)).textContent;
                let resultId = input.id;

                let hotelResult = findIn(`[data-render-booking-names-result-hotel-id="${hotelTitle}"]`, result);
                if(!hotelResult || hotelResult.length === 0) {
                    hotelResult = document.createElement("div");
                    hotelResult.setAttribute("data-render-booking-names-result-hotel-id", hotelTitle);
                    result.appendChild(hotelResult);

                    render(
                        <RenderTitle
                            hotelTitle={hotelTitle}
                        />,
                        hotelResult);
                }

                let customResult = findIn(`[data-render-booking-names-result-id="${resultId}"]`, result);

                if(!customResult || customResult.length === 0) {
                    customResult = document.createElement("div");
                    customResult.setAttribute("data-render-booking-names-result-id", resultId);
                    hotelResult.appendChild(customResult);
                }

                render(
                    <RenderInputList
                        roomTitle={roomTitle}
                        category={renderCategory}
                        name={renderName}
                        defaultRows={rowsObj}
                    />,
                    customResult);
            }, counterInput);
        })

    });
}

function RenderTitle({
     hotelTitle = "",
 }) {
    return (
        <h2 className="text-uppercase h4">{hotelTitle}</h2>
    )
}

function RenderInputList({
         roomTitle = "",
         category = "",
         name = "",
         defaultRows = []
     }) {
    const [rows, setRows] = useState(defaultRows);

    useEffect(function() {
        setRows(defaultRows);
    }, defaultRows)

    return (
        <div>
            { category ? (
                <h3 className="h6 mb-3">{ category }</h3>
            ) : ""}

            {rows.map((id, key) => (
                <div className="mb-4" key={key}>
                    <div className="h6 mb-2">
                        {key+1}. { roomTitle }
                    </div>
                    <div>
                        <FormInput
                            id={`${name}-${id}`}
                            name={`${name}[${id}]`}
                            label={translate('congress.customerName')}
                            defaultVal=""
                        />
                    </div>
                </div>
            ))}
        </div>

    )
};

function FormInput({
       id = "",
       name = "",
       label = "",
       defaultVal = ""
   }) {
    const [value, setValue] = useState(defaultVal);

    const changeHandler = (evt) => {
        let newInput = escapeHtml(evt.target.value);
        setValue(newInput );
    };

    return (
        <div className={`form-group has-value`}>
            <div className="position-relative">
                <label className="form-control-label floating-label" htmlFor={id}>
                    {label}
                    <span title="Pflichtfeld" aria-label="Pflichtfeld">*</span>
                </label>
                <input type="text" id={id} name={name}
                       data-label-hide = "1"
                       required
                       placeholder={label}
                       className="form-control border-muted js-floating-label has-value js-form-step__guest-name" onInput={(evt) => {
                    changeHandler(evt);
                }}/>
            </div>
        </div>
    )
};